"use strict";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoUploadType = exports.VideoTrailerType = exports.VideoStatus = exports.VideoSource = exports.VideoResetType = exports.VideoPricingType = exports.VideoPlayType = exports.VideoGenerateType = exports.VideoCardUploadType = exports.VideoCardType = exports.VideoCardTargetExternalType = exports.VideoCardPosition = exports.SettingsDefaultPricingType = exports.MutationStatus = exports.MediaStatus = exports.LogoVisibility = exports.LiveStatus = exports.ExternalVideoSource = exports.EntitiesSortingOrder = exports.ChannelUploadType = exports.ChannelSource = exports.ChannelPricingType = exports.ChannelMediaSource = void 0;
//==============================================================
// START Enums and Input Objects
//==============================================================
var ChannelMediaSource;
(function (ChannelMediaSource) {
    ChannelMediaSource["MEDIA_PLATFORM"] = "MEDIA_PLATFORM";
    ChannelMediaSource["PRIVATE_MEDIA"] = "PRIVATE_MEDIA";
    ChannelMediaSource["PRIVATE_MEDIA_V3"] = "PRIVATE_MEDIA_V3";
    ChannelMediaSource["YOUTUBE"] = "YOUTUBE";
})(ChannelMediaSource = exports.ChannelMediaSource || (exports.ChannelMediaSource = {}));
var ChannelPricingType;
(function (ChannelPricingType) {
    ChannelPricingType["PRICING_PLAN"] = "PRICING_PLAN";
    ChannelPricingType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(ChannelPricingType = exports.ChannelPricingType || (exports.ChannelPricingType = {}));
var ChannelSource;
(function (ChannelSource) {
    ChannelSource["INTERNAL"] = "INTERNAL";
    ChannelSource["YOUTUBE"] = "YOUTUBE";
})(ChannelSource = exports.ChannelSource || (exports.ChannelSource = {}));
var ChannelUploadType;
(function (ChannelUploadType) {
    ChannelUploadType["COVER"] = "COVER";
    ChannelUploadType["TRAILER"] = "TRAILER";
})(ChannelUploadType = exports.ChannelUploadType || (exports.ChannelUploadType = {}));
var EntitiesSortingOrder;
(function (EntitiesSortingOrder) {
    EntitiesSortingOrder["CUSTOM_ASC"] = "CUSTOM_ASC";
    EntitiesSortingOrder["CUSTOM_DESC"] = "CUSTOM_DESC";
    EntitiesSortingOrder["TITLE_ASC"] = "TITLE_ASC";
    EntitiesSortingOrder["TITLE_DESC"] = "TITLE_DESC";
    EntitiesSortingOrder["UPDATED_ASC"] = "UPDATED_ASC";
    EntitiesSortingOrder["UPDATED_DESC"] = "UPDATED_DESC";
})(EntitiesSortingOrder = exports.EntitiesSortingOrder || (exports.EntitiesSortingOrder = {}));
var ExternalVideoSource;
(function (ExternalVideoSource) {
    ExternalVideoSource["DROPBOX"] = "DROPBOX";
    ExternalVideoSource["FACEBOOK"] = "FACEBOOK";
    ExternalVideoSource["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    ExternalVideoSource["VIMEO"] = "VIMEO";
    ExternalVideoSource["YOUTUBE"] = "YOUTUBE";
})(ExternalVideoSource = exports.ExternalVideoSource || (exports.ExternalVideoSource = {}));
var LiveStatus;
(function (LiveStatus) {
    LiveStatus["DVR_PROCESSING"] = "DVR_PROCESSING";
    LiveStatus["EXPIRED"] = "EXPIRED";
    LiveStatus["FINISHED"] = "FINISHED";
    LiveStatus["PENDING"] = "PENDING";
    LiveStatus["RECONNECTING"] = "RECONNECTING";
    LiveStatus["SCHEDULED"] = "SCHEDULED";
    LiveStatus["STREAMING"] = "STREAMING";
})(LiveStatus = exports.LiveStatus || (exports.LiveStatus = {}));
var LogoVisibility;
(function (LogoVisibility) {
    LogoVisibility["ALWAYS"] = "ALWAYS";
    LogoVisibility["CONTROL_BAR"] = "CONTROL_BAR";
})(LogoVisibility = exports.LogoVisibility || (exports.LogoVisibility = {}));
var MediaStatus;
(function (MediaStatus) {
    MediaStatus["FAILED"] = "FAILED";
    MediaStatus["INITIALIZED"] = "INITIALIZED";
    MediaStatus["IN_PROGRESS"] = "IN_PROGRESS";
    MediaStatus["IN_QUEUE"] = "IN_QUEUE";
    MediaStatus["PREVIEW_READY"] = "PREVIEW_READY";
    MediaStatus["READY"] = "READY";
})(MediaStatus = exports.MediaStatus || (exports.MediaStatus = {}));
var MutationStatus;
(function (MutationStatus) {
    MutationStatus["ERROR"] = "ERROR";
    MutationStatus["SUCCESS"] = "SUCCESS";
})(MutationStatus = exports.MutationStatus || (exports.MutationStatus = {}));
var SettingsDefaultPricingType;
(function (SettingsDefaultPricingType) {
    SettingsDefaultPricingType["RENT"] = "RENT";
    SettingsDefaultPricingType["SALE"] = "SALE";
})(SettingsDefaultPricingType = exports.SettingsDefaultPricingType || (exports.SettingsDefaultPricingType = {}));
var VideoCardPosition;
(function (VideoCardPosition) {
    VideoCardPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    VideoCardPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    VideoCardPosition["TOP_LEFT"] = "TOP_LEFT";
    VideoCardPosition["TOP_RIGHT"] = "TOP_RIGHT";
})(VideoCardPosition = exports.VideoCardPosition || (exports.VideoCardPosition = {}));
var VideoCardTargetExternalType;
(function (VideoCardTargetExternalType) {
    VideoCardTargetExternalType["FACEBOOK"] = "FACEBOOK";
    VideoCardTargetExternalType["TWITTER"] = "TWITTER";
    VideoCardTargetExternalType["YOUTUBE"] = "YOUTUBE";
})(VideoCardTargetExternalType = exports.VideoCardTargetExternalType || (exports.VideoCardTargetExternalType = {}));
var VideoCardType;
(function (VideoCardType) {
    VideoCardType["CHANNEL"] = "CHANNEL";
    VideoCardType["CUSTOM"] = "CUSTOM";
    VideoCardType["PRODUCT"] = "PRODUCT";
    VideoCardType["RECENT_VIDEO"] = "RECENT_VIDEO";
    VideoCardType["SOCIAL"] = "SOCIAL";
    VideoCardType["VIDEO"] = "VIDEO";
})(VideoCardType = exports.VideoCardType || (exports.VideoCardType = {}));
var VideoCardUploadType;
(function (VideoCardUploadType) {
    VideoCardUploadType["THUMBNAIL"] = "THUMBNAIL";
})(VideoCardUploadType = exports.VideoCardUploadType || (exports.VideoCardUploadType = {}));
var VideoGenerateType;
(function (VideoGenerateType) {
    VideoGenerateType["TRAILER"] = "TRAILER";
})(VideoGenerateType = exports.VideoGenerateType || (exports.VideoGenerateType = {}));
var VideoPlayType;
(function (VideoPlayType) {
    VideoPlayType["AUTOGENERATED_TRAILER"] = "AUTOGENERATED_TRAILER";
    VideoPlayType["CLIP"] = "CLIP";
    VideoPlayType["CONTENT"] = "CONTENT";
    VideoPlayType["DEFAULT_TRAILER"] = "DEFAULT_TRAILER";
    VideoPlayType["STORYBOARD"] = "STORYBOARD";
    VideoPlayType["TRAILER"] = "TRAILER";
    VideoPlayType["UPLOADED_TRAILER"] = "UPLOADED_TRAILER";
})(VideoPlayType = exports.VideoPlayType || (exports.VideoPlayType = {}));
var VideoPricingType;
(function (VideoPricingType) {
    VideoPricingType["RENT"] = "RENT";
    VideoPricingType["SALE"] = "SALE";
})(VideoPricingType = exports.VideoPricingType || (exports.VideoPricingType = {}));
var VideoResetType;
(function (VideoResetType) {
    VideoResetType["CONTENT"] = "CONTENT";
    VideoResetType["COVER"] = "COVER";
    VideoResetType["POSTER"] = "POSTER";
    VideoResetType["TRAILER"] = "TRAILER";
})(VideoResetType = exports.VideoResetType || (exports.VideoResetType = {}));
var VideoSource;
(function (VideoSource) {
    VideoSource["COMPUTER"] = "COMPUTER";
    VideoSource["DROPBOX"] = "DROPBOX";
    VideoSource["FACEBOOK"] = "FACEBOOK";
    VideoSource["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    VideoSource["LIVE"] = "LIVE";
    VideoSource["VIMEO"] = "VIMEO";
    VideoSource["YOUTUBE"] = "YOUTUBE";
})(VideoSource = exports.VideoSource || (exports.VideoSource = {}));
var VideoStatus;
(function (VideoStatus) {
    VideoStatus["FAILED"] = "FAILED";
    VideoStatus["INIT"] = "INIT";
    VideoStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VideoStatus["OVER_QUOTA"] = "OVER_QUOTA";
    VideoStatus["VISIBLE"] = "VISIBLE";
})(VideoStatus = exports.VideoStatus || (exports.VideoStatus = {}));
var VideoTrailerType;
(function (VideoTrailerType) {
    VideoTrailerType["AUTOGENERATED"] = "AUTOGENERATED";
    VideoTrailerType["DEFAULT"] = "DEFAULT";
    VideoTrailerType["UPLOADED"] = "UPLOADED";
})(VideoTrailerType = exports.VideoTrailerType || (exports.VideoTrailerType = {}));
var VideoUploadType;
(function (VideoUploadType) {
    VideoUploadType["CONTENT"] = "CONTENT";
    VideoUploadType["COVER"] = "COVER";
    VideoUploadType["POSTER"] = "POSTER";
    VideoUploadType["TRAILER"] = "TRAILER";
})(VideoUploadType = exports.VideoUploadType || (exports.VideoUploadType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map